module.exports = __webpack_public_path__ + "img/coupons_bg_tw.aae0511d.png";